// hooks
import { useContext } from "react";
// contexts
import { CollapseDrawerContext } from "providers/CollapseDrawerContext";
import { AuthContext } from "providers/AuthContext";
import { HelmetContext } from "../providers";

const useCollapseDrawer = () => {
  return useContext(CollapseDrawerContext);
};
const useAuth = () => {
  return useContext(AuthContext);
};
const useHelmet = () => {
  return useContext(HelmetContext);
};

export { useCollapseDrawer, useAuth, useHelmet };
